import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Col, Nav } from "react-bootstrap";
import {
  CaretDoubleRight,
  MapPin,
  Phone,
  EnvelopeSimple,
} from "@phosphor-icons/react";
import youtubeIcon from "../img/youtube.svg";
import linkedinIcon from "../img/linkedin.svg";
import { useSelector } from "react-redux";
import { ADMIN_LOGIN_URL } from "../config/Constant";
import { getActiveLang, withLang } from "../utils/language";
import { smartConvertNumber } from "../utils/odiaNumberConverter";


function Footer({ data }) {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedLanguage = getActiveLang();

  const CMSData = useSelector(
    (state) => state.cmsdatadetail.cmsdatadetail || {},
  );
  const {
    address: FooterAddressData = {},
    email: FooterEmailData = {},
    helpline: FooterHelplineData = {},
    last_updated_on: LastUpdatedData = {},
    social_facebook: SocialFacebook = {},
    social_instagram: SocialInstagram = {},
    social_twitter: SocialTwitter = {},
    social_youtube: SocialYoutube = {},
    social_linkedin: SocialLinkedin = {},
    copyright: CopyRight = {},
    site_visitors: SiteVisitorsData = {}
  } = CMSData;

  const [stats] = useState(data?.value || SiteVisitorsData?.title_en || '22808');

  useEffect(() => {
    if (location.state?.targetSection) {
      const section = document.getElementById(location.state.targetSection);
      section?.scrollIntoView({ behavior: "smooth" });
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const scrollToTop = () => {
    navigate(withLang("/"));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleClickAdmin = () => {
    window.open(ADMIN_LOGIN_URL, "_blank", "noopener,noreferrer");
  };

  const isOriya = selectedLanguage === "ori";

  const text = useMemo(
    () => ({
      quickLinks: isOriya ? "ତ୍ୱରିତ ଲିଙ୍କ" : "Quick Links",
      importantLinks: isOriya ? "ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ଲିଙ୍କ" : "Important Links",
      contactUs: isOriya ? "ଆମକୁ" : "Us",
      home: isOriya ? "ମୁଖ୍ୟ ପୃଷ୍ଠା" : "Home",
      about: isOriya ? "ଆମ ବିଷୟରେ" : "About Us",
      faqs: isOriya ? "ବାରମ୍ବାର ପଚରା ଯାଇଥିବା ପ୍ରଶ୍ନ" : "FAQs",
      terms: isOriya ? "ନିୟମ ଏବଂ ସର୍ତ୍ତାବଳୀ" : "Terms & Conditions",
      privacy: isOriya ? "ଗୋପନୀୟତା ନୀତି" : "Privacy Policy",
      admin: isOriya ? "ଅଫିସର୍ ଲଗିନ୍" : "Admin Login",
      deptAgri: isOriya
        ? "କୃଷି ଓ କୃଷକ ସଶକ୍ତିକରଣ ବିଭାଗ"
        : "Department of Agriculture & Farmer Empowerment",
      deptFish: isOriya
        ? "ମତ୍ସ୍ୟ ଏବଂ ପ୍ରାଣୀ ସମ୍ପଦ ବିକାଶ ବିଭାଗ"
        : "Fisheries & Animal Resource Development Department",
      siteVisitors: isOriya ? "ସାଇଟ୍ ପରିଦର୍ଶକ" : "Site Visitors",
      contact: isOriya ? "ସଂପର୍କ କରନ୍ତୁ " : "Contact ",
      // StaticCount: isOriya ? "୨୭୦୮୨ " : "27082",
    }),
    [isOriya],
  );

  const socialLinks = [
    {
      icon: SocialFacebook?.logo,
      url: SocialFacebook?.title_en,
      alt: "facebook",
    },
    {
      icon: SocialInstagram?.logo,
      url: SocialInstagram?.title_en,
      alt: "instagram",
    },
    { icon: SocialTwitter?.logo, url: SocialTwitter?.title_en, alt: "twitter" },
    // { icon: youtubeIcon, url: SocialYoutube?.title_en, alt: "youtube" },
    // { icon: linkedinIcon, url: SocialLinkedin?.title_en, alt: "linkedin" },
  ];

  const FooterLink = ({ to, label, external = false, onClick }) => (
    <li>
      <Nav.Link
        className="inline-block"
        as={Link}
        to={external ? to : withLang(to)}
        target={external ? "_blank" : undefined}
        onClick={onClick}
      >
        <CaretDoubleRight size={16} weight="bold" />
        {label}
      </Nav.Link>
    </li>
  );

  return (
    <>
      <div className="footerSection">
        <Container>
          <Row>
            <Col lg={3} sm={12}>
              <h4>
                <span>{text.quick}</span>
                {text.quickLinks}
              </h4>
              <ul>
                <FooterLink
                  label={text.admin}
                  to="/"
                  onClick={handleClickAdmin}
                />
                <FooterLink label={text.home} to="/" onClick={scrollToTop} />
                <FooterLink label={text.faqs} to="/faq" onClick={scrollToTop} />
                <FooterLink
                  label={text.about}
                  to="/about"
                  onClick={scrollToTop}
                />
                <FooterLink
                  label={text.terms}
                  to="/termsConditions"
                  onClick={scrollToTop}
                />
                <FooterLink
                  label={text.privacy}
                  to="/privacyPolicy"
                  onClick={scrollToTop}
                />
              </ul>
            </Col>

            <Col lg={5} sm={12}>
              <h4>
                <span>{text.important}</span>
                {text.importantLinks}
              </h4>
              <ul>
                <FooterLink
                  label={text.deptAgri}
                  to="https://agri.odisha.gov.in/"
                  external
                />
                <FooterLink
                  label={text.deptFish}
                  to="https://fard.odisha.gov.in/"
                  external
                />
              </ul>
            </Col>

            <Col lg={4} sm={12}>
              <h4 className="contact-us">
                <span>{text.contact}</span>
                {text.contactUs}
              </h4>
              <ul className="w-80">
                {FooterAddressData?.title_en && (
                  <li>
                    <a
                      href="https://maps.app.goo.gl/BcUz3ih4MZtPqTer8"
                      target="_blank"
                      rel="noreferrer"
                      className="footerLink"
                    >
                      <MapPin size={20} weight="bold" />
                      <span>
                        {isOriya
                          ? FooterAddressData.title_ori
                          : FooterAddressData.title_en}
                      </span>
                    </a>
                  </li>
                )}
                {FooterEmailData?.description_en && (
                  <li>
                    <a href={`mailto:${FooterEmailData.description_en}`}>
                      <EnvelopeSimple size={20} weight="bold" />
                      <span>
                        {isOriya
                          ? FooterEmailData.title_ori
                          : FooterEmailData.title_en}
                        :{" "}
                        {isOriya
                          ? FooterEmailData.description_ori
                          : FooterEmailData.description_en}
                      </span>
                    </a>
                  </li>
                )}
                {FooterHelplineData?.description_en && (
                  <li>
                    <a href="tel:155333">
                      <Phone size={20} weight="bold" />
                      <span>
                        {isOriya
                          ? FooterHelplineData.title_ori
                          : FooterHelplineData.title_en}
                        :{" "}
                        {isOriya
                          ? FooterHelplineData.description_ori
                          : FooterHelplineData.description_en}
                      </span>
                    </a>
                  </li>
                )}
              </ul>

              <div className="social_media mt-2">
                <ol className="follow-us">
                  {socialLinks.map(
                    (item, idx) =>
                      item.icon && (
                        <li key={idx}>
                          <a href={item.url} target="_blank" rel="noreferrer">
                            <img src={item.icon} alt={item.alt} />
                          </a>
                        </li>
                      ),
                  )}
                </ol>
              </div>

              <span className="visitors_info">
                {text.siteVisitors} :{" "}
                {smartConvertNumber(stats)}
              </span>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="copyRight">
        <p>
          © {smartConvertNumber(String(new Date().getFullYear()))} {" "}
          {isOriya ? CopyRight?.title_ori : CopyRight?.title_en}
          
        </p>
        <span
            dangerouslySetInnerHTML={{
              __html: isOriya
                ? LastUpdatedData?.title_ori
                : LastUpdatedData?.title_en,
            }}
          />
      </div>
    </>
  );
}

export default Footer;
